import React from 'react';
import { FormPage } from '../pages/Form/Form';
import { ROUTES } from '../common/constants/defaultStaticUrls';
import { LocalizationErrorPage, PlateNumberErrorPage, SuccessPage } from '../pages/Information';
import { NotFoundPage } from '../pages/NotFound/NotFoundPage';

export const routing = [
  {
    path: ROUTES.HOME,
    element: <FormPage />,
  },
  {
    path: ROUTES.SUCCESS,
    element: <SuccessPage />,
  },
  {
    path: ROUTES.PLATE_NUMBER_ERROR,
    element: <PlateNumberErrorPage />,
  },
  {
    path: ROUTES.LOCALIZATION_ERROR,
    element: <LocalizationErrorPage />,
  },
  {
    path: ROUTES.NOT_FOUND,
    element: <NotFoundPage />,
  },
];
